import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";

export default function SignUp({ signUp, form, onChange, onChangeCheck, isLoading }) {
  const [step, setStep] = useState(1);
  const steps = [
    { id: 1, title: "Шаг 1. Название" },
    { id: 2, title: "Шаг 2. Параметры меню" },
    { id: 3, title: "Шаг 3. Данные администратора" },
  ];
  const progress = Math.round((step / steps.length) * 100);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (step < steps.length) {
      setStep(step + 1);
      return;
    }
    signUp(e);
  };

  const prevStep = () => setStep((s) => Math.max(1, s - 1));

  return (
    <Form onSubmit={handleSubmit} className="glass-panel floating-card signup-card">
      <div className="signup-head">
        <div>
          <p className="text-uppercase text-primary fw-semibold mb-1" style={{ letterSpacing: ".08em" }}>
            Регистрация
          </p>
          <h4 className="fw-bold m-0">Создайте команду</h4>
          <p className="page-subtitle m-0">Три шага — и команда уже в новом кабинете.</p>
        </div>

        <div className="signup-progress">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="fw-semibold">Прогресс регистрации</span>
            <span className="small text-muted">{progress}%</span>
          </div>
          <div className="progress signup-progress__bar">
            <div className="progress-bar" style={{ width: `${progress}%` }} />
          </div>
          <div className="signup-steps">
            {steps.map((item) => (
              <div
                key={item.id}
                className={`signup-step ${step === item.id ? "active" : ""} ${step > item.id ? "done" : ""}`}
              >
                <span className="step-index">{item.id}</span>
                <span className="step-title">{item.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="signup-panel">
        {step === 1 && (
          <>
            <h5 className="fw-semibold">Данные команды</h5>
            <Form.Group className="mb-3">
              <Form.Label>Название команды</Form.Label>
              <Form.Control
                type="text"
                placeholder="Введите название"
                value={form.teamName}
                onChange={onChange}
                name="teamName"
              />
            </Form.Group>
          </>
        )}

        {step === 2 && (
          <>
            <h5 className="fw-semibold">Параметры меню</h5>
            <div className="signup-switches">
              <Form.Check
                type="switch"
                label="Включить меню в Милти"
                name="mealtyMenu"
                checked={form.mealtyMenu === true}
                onChange={onChangeCheck}
              />
              <Form.Check
                type="switch"
                label="Выгружать заказ в Милти"
                name="mealtyExport"
                checked={form.mealtyExport === true}
                onChange={onChangeCheck}
              />
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <h5 className="fw-semibold">Данные администратора</h5>
            <Form.Group className="mb-3">
              <Form.Label>Имя</Form.Label>
              <Form.Control
                type="text"
                placeholder="Введите имя"
                value={form.name}
                onChange={onChange}
                name="name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Введите Email"
                value={form.email}
                onChange={onChange}
                name="email"
              />
            </Form.Group>

            <Form.Group className="mb-0">
              <Form.Label>Пароль</Form.Label>
              <Form.Control
                type="password"
                placeholder="Введите пароль"
                value={form.password}
                onChange={onChange}
                name="password"
                autoComplete="new-password"
              />
            </Form.Group>
          </>
        )}
      </div>

      <div className="signup-actions">
        {step > 1 ? (
          <Button variant="outline-primary" type="button" onClick={prevStep} disabled={isLoading} className="px-4">
            Назад
          </Button>
        ) : (
          <span />
        )}
        <Button variant="primary" type="submit" disabled={isLoading} className="w-100 py-3">
          {step === steps.length ? (isLoading ? "Загрузка..." : "Зарегистрироваться") : "Далее"}
        </Button>
      </div>
    </Form>
  );
}
